import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SnackBarModal from '@components/SnackBar';
import { hideSnackBar as actionHideSnackBar } from '@store/common/actions';

const SnackBarScreen = (props) => {
  const { snackBar } = useSelector((state) => state.common);

  const { title, showSnackBar, ...propsSnackBar } = snackBar;

  const dispatch = useDispatch();

  /* if (timer && showSnackBar){
    setTimeout(() => hideSnackBar(), timer);
  } */
  const hideSnackBar = () => {
    dispatch(actionHideSnackBar());
  };

  return (
    <SnackBarModal
      title={title}
      open={showSnackBar}
      id="snack-bar"
      handleClose={() => hideSnackBar()}
      onBlur={() => hideSnackBar()}
      {...propsSnackBar}
    />
  );
};

export default SnackBarScreen;
